export enum LoggedInUserValidateErrorConstants {
  LOOSELEAF_ALREADY_PURCHASED = 'LooseLeaf already purchased.',
  NO_CONNECT_LICENSE = 'No Connect license.',
}